import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IRREGULARITIES } from '../../routes';
import {
  fetchGetIrregularityById,
  irregularitiesSlice,
  useDispatch,
  useSelector,
} from '../../stores';
import { handleApiReturn, handleDateTime } from '../../utils';

const LabelText = ({
  label,
  value,
  fontSize,
}: {
  label: string;
  value?: string;
  fontSize: string;
}) => (
  <Typography
    color='text.secondary'
    sx={{
      fontSize,
      width: '100%',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }}
  >
    <Box component='span' sx={{ fontWeight: 'bold' }}>
      {label}:
    </Box>{' '}
    {value}
  </Typography>
);

export const IrregularityCard = (props: {
  item:
    | {
        id: number;
        licensePlate: string;
        vehicleCategory: string;
        vehicleBrand: string | null;
        observation: string | null;
        photoPlate: string;
        registrationDateTime: string;
      }
    | undefined;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { driverId } = useSelector((state) => state.profileReducer);

  const handleIrregularityClick = (irregularityId: string) => {
    dispatch(
      fetchGetIrregularityById({
        driverId: driverId.toString(),
        irregularityId: irregularityId,
      }),
    ).then((res: any) => {
      handleApiReturn(
        res,
        () => {
          dispatch(irregularitiesSlice.actions.toggleShowDetails());
          navigate(IRREGULARITIES);
        },
        null,
      );
    });
  };

  return (
    <Card
      sx={{
        cursor: 'pointer',
        height: {
          xs: 275,
          sm: 200,
        },
        width: {
          xs: 205,
          sm: 400,
        },
        borderRadius: '14px',
        overflow: 'hidden',
        margin: '10px',
      }}
      onClick={() =>
        handleIrregularityClick(props.item ? props.item.id.toString() : '')
      }
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
          height: '100%',
          width: {
            xs: 205,
            sm: 400,
          },
          padding: 0,
          '&:last-child': {
            paddingBottom: 0,
          },
        }}
      >
        <CardContent
          sx={{
            display: {
              xs: 'none',
              sm: 'flex',
            },
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            width: '50%',
            height: '100%',
            minWidth: 0,
            maxWidth: '50%',
            boxSizing: 'border-box',
            overflow: 'hidden',
            padding: '12px',
          }}
        >
          <Typography variant='h6' color='primary' noWrap sx={{ width: '100%' }}>
            {props.item?.id}
          </Typography>
          <Typography
            gutterBottom
            color='text.secondary'
            noWrap
            sx={{
              fontSize: '16px',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {handleDateTime(props.item?.registrationDateTime)}
          </Typography>
          <LabelText label='Placa' value={props.item?.licensePlate} fontSize='16px' />
          <LabelText
            label='Categoria'
            value={props.item?.vehicleCategory}
            fontSize='16px'
          />
          {props.item?.vehicleBrand ? (
            <LabelText label='Modelo' value={props.item.vehicleBrand} fontSize='16px' />
          ) : null}
        </CardContent>
        <CardMedia
          sx={{
            height: {
              xs: '50%',
              sm: '100%',
            },
            width: {
              xs: '100%',
              sm: '50%',
            },
            flexShrink: 0,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderTopRightRadius: {
              sm: '14px',
              xs: 0,
            },
            borderBottomRightRadius: {
              sm: '14px',
              xs: 0,
            },
            borderTopLeftRadius: {
              sm: 0,
              xs: '14px',
            },
          }}
          image={props.item?.photoPlate}
        />
        <CardContent
          sx={{
            display: {
              xs: 'flex',
              sm: 'none',
            },
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            width: '100%',
            height: '50%',
            minWidth: 0,
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden',
            padding: '8px 12px',
          }}
        >
          <Typography variant='h6' color='primary' noWrap sx={{ width: '100%' }}>
            {props.item?.id}
          </Typography>
          <Typography
            gutterBottom
            color='text.secondary'
            noWrap
            sx={{
              fontSize: '14px',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {handleDateTime(props.item?.registrationDateTime)}
          </Typography>
          <LabelText label='Placa' value={props.item?.licensePlate} fontSize='14px' />
          <LabelText
            label='Categoria'
            value={props.item?.vehicleCategory}
            fontSize='14px'
          />
          {props.item?.vehicleBrand ? (
            <LabelText label='Modelo' value={props.item.vehicleBrand} fontSize='14px' />
          ) : null}
        </CardContent>
      </CardContent>
    </Card>
  );
};
